import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'ProcessingAgency/List', method: 'POST', body: filter, token: token })
}
